import './App.css';
import React, { Suspense, lazy } from 'react';
import Header from './components/Header';
import { Routes, Route, useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import Cart from './components/Cart';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { CategoryProvider } from './context/CategoryContext';
import WhatsAppWidget from './components/WhatsAppWidget';
import Wishlist from './components/Wishlist';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from 'react-hot-toast';
import SEO from './components/SEO';

import Home from './components/Home';
import ContactUs from './components/ContactUsScreen/ContactUs';
import AboutUs from './components/AboutUs';
import Shop from './components/Shop';
import CategoryProducts from './pages/CategoryProducts';
import Scalfoldinghirepage from './pages/Services/Scalfoldinghirepage';
import KitchenWardrobeFittingPage from './pages/Services/Kitchen&WardrobeFitting';
import GypsumCeilingSolutions from './pages/Services/GypsumCeilingSolutions';
import TvGypsumWallUnitsPage from './pages/Services/Tv&GypsumwallUnits';
import WainScoutingPanel from './pages/Services/WainScoutingPanel';
import Services from './pages/Services/Services';
import Project from './pages/Services/Project';
import InteriorDesignNairobi from './pages/Locations/InteriorDesignNairobi';
import GypsumCeilingsNairobi from './pages/Locations/GypsumCeilingsNairobi';
import KitchenCabinetsNairobi from './pages/Locations/KitchenCabinetsNairobi';
import OfficeFitoutsKenya from './pages/Locations/OfficeFitoutsKenya';
import NotFound from './components/NotFound';
import CookiePolicy from './pages/Legal/CookiePolicy';
import PrivacyPolicy from './pages/Legal/PrivacyPolicy';
import TermsAndConditions from './pages/Legal/Terms&Conditions';
import ReturnAndRefund from './pages/Legal/Return&Refund';
import ElectricalServices from './pages/Services/ElectricalServices';
import SoundproofingPage from './pages/Services/Soundproofing';
import RenderingVisualizationPage from './pages/Services/3D renderingandvisualations';

const Checkout = lazy(() => import('./components/Checkout'));
const ProductId = lazy(() => import('./components/ProductId'));
const ProjectDetails = lazy(() => import('./pages/Services/ProjectDetails'));
const Login = lazy(() => import('./components/Login'));
const Register = lazy(() => import('./components/Register'));
const GoogleCallback = lazy(() => import('./components/GoogleCallback'));
const Profile = lazy(() => import('./components/Profile'));
const Orders = lazy(() => import('./components/Orders'));


function App() {
  const location = useLocation();
  const noindexRoutes = ['/cart', '/checkout', '/wishlist', '/profile', '/orders', '/login', '/register', '/auth/', '/shop', '/category/'];
  const shouldNoindex = noindexRoutes.some((routePrefix) => location.pathname.startsWith(routePrefix));

  return (
    <CartProvider>
      <WishlistProvider>
        <CategoryProvider>
          <Header />
          <WhatsAppWidget />
          {shouldNoindex && (
            <SEO
              title="User Account | Techie Interiors"
              description="User and transactional page."
              noindex
              url={`https://techieinteriors.co.ke${location.pathname}`}
            />
          )}
          <main id="main-content">
            <Suspense fallback={<div className="page-loading" aria-live="polite">Loading...</div>}>
              <Routes>
                <Route path='/' element={<Home />} />
                <Route path='cart' element={<Cart />} />
                <Route path='wishlist' element={
                  <ProtectedRoute>
                    <Wishlist />
                  </ProtectedRoute>
                } />
                <Route path='contact-us' element={<ContactUs />} />
                <Route path='about-us' element={<AboutUs />} />
                <Route path='shop' element={<Shop />} />
                <Route path='checkout' element={<Checkout />} />
                <Route path='product/:id' element={<ProductId />} />
                <Route path='category/:category' element={<CategoryProducts />} />
                <Route path='scafolding-hire' element={<Scalfoldinghirepage />} />
                <Route path='kitchen-wardrobe-fitting' element={<KitchenWardrobeFittingPage />} />
                <Route path='gypsum-ceiling' element={<GypsumCeilingSolutions />} />
                <Route path='tv-gypsum-wall' element={<TvGypsumWallUnitsPage />} />
                <Route path='wain-scouting' element={<WainScoutingPanel />} />
                <Route path='services' element={<Services />} />
                <Route path='project' element={<Project />} />
                <Route path='project/:projectId' element={<ProjectDetails />} />
                <Route path='interior-design-nairobi' element={<InteriorDesignNairobi />} />
                <Route path='gypsum-ceilings-nairobi' element={<GypsumCeilingsNairobi />} />
                <Route path='kitchen-cabinets-nairobi' element={<KitchenCabinetsNairobi />} />
                <Route path='office-fitouts-kenya' element={<OfficeFitoutsKenya />} />
                <Route path='login' element={<Login />} />
                <Route path='register' element={<Register />} />
                <Route path='auth/google/callback' element={<GoogleCallback />} />
                <Route path='profile' element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } />
                <Route path='orders' element={
                  <ProtectedRoute>
                    <Orders />
                  </ProtectedRoute>
                } />
                <Route path='cookie-policy' element={<CookiePolicy />} />
                <Route path='privacy-policy' element={<PrivacyPolicy />} />
                <Route path='terms-and-conditions' element={<TermsAndConditions />} />
                <Route path='return-policy' element={<ReturnAndRefund />} />
                <Route path='electrical' element={<ElectricalServices />} />
                <Route path='soundproofing' element={<SoundproofingPage />} />
                <Route path='3d-rendering-visualization' element={<RenderingVisualizationPage />} />
                <Route path='404.html' element={<NotFound />} />
                <Route path='*' element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#4ade80',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 3000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </CategoryProvider>
      </WishlistProvider>
    </CartProvider>
  );
}

export default App;
